export default "__VITE_ASSET__85648dab__"